import { render, staticRenderFns } from "./DrawingsCanvas.vue?vue&type=template&id=3b079986"
import script from "./DrawingsCanvas.vue?vue&type=script&lang=js"
export * from "./DrawingsCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports